import $ from 'jquery';
import EventEmitter from '../event-emitter';
import inherit from '../inherit';

function VideoCollection(initialData = []) {
  EventEmitter.call(this);
  this.collection   = initialData.map((each, idx) => {
    each.index = idx;
    return each;
  });
  this.relatedClips = {};
  this.length       = initialData.length;
}

inherit(VideoCollection, EventEmitter, {
  /**
   * 기본적으로는 Array.prototype.filter와 동일
   * 중간에 break 하는게 나아서 만듦
   * @param {Function} condition
   * @returns {Clip}
   */
  getClip(condition) {
    const coll = this.collection;
    const len  = coll.length;
    for (let i = 0; i < len; i++) {
      const clip = coll[i];
      if (condition(clip, i)) {
        return clip;
      }
    }
  },
  get({ id, where }) {
    return where === 'playlist' ? this.relatedClips[id] : this.getClip((clip) => clip.videoId === id);
  },
  getByIndex(idx) {
    return this.collection[idx];
  },
  getAssignedClip(key) {
    return this.collection[key];
  },
  addIndex(clips) {
    return clips.map((clip) => {
      this.length++;
      clip.index = this.length - 1;
      return clip;
    });
  },
  push(clips, callback) {
    const clipsIndexAdded = this.addIndex(clips);
    this.collection       = this.collection.concat(clipsIndexAdded);
    this.emit('push', clipsIndexAdded, callback);
  },
  assign(key, value) {
    this.relatedClips[key] = value;
    this.emit('assign', value);
  },
  update(clip, newProperties) {
    this.emit('update', $.extend(clip, newProperties));
  },
  on(...args) {
    EventEmitter.prototype.on.apply(this, args);
    return this;
  }
});

export default VideoCollection;


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/core/video-collection/index.js
 **/